module.exports = __webpack_public_path__ + "img/explainer-10.26bb25fb.jpg";